import React, { useEffect } from 'react';
import './programassociales.css';
import { programassociales } from '../../json/programassociales';

const Atencionmigrante = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className='container-full-width'>
      <div className='row'>
        <div className='col-12'>
          <h3 className='title'>Programa "Atención al Migrante"</h3>
          <hr className='hr-gob' />
        </div>
      </div>

      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
             
              <div style={{ textAlign: 'left' }}>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Descripción del Programa</h5>
                <p>
              
                </p>
                <h6 className='description' style={{ marginTop: '20px' }}>
                El programa de Atención al Migrante está diseñado para proporcionar apoyo integral a la población migrante hidalguense en el exterior, en retorno y a sus fami lias que radican en el estado, a través de diversas iniciativas como la entrega de apoyos económicos, la reunificación familiar, servicio de traslado de restos y apoyo a las comunidades en el exterior; este esfuerzo integral busca no solo mej orar las condiciones económicas de los migrantes, si no también asegurar su bienestar y el de sus seres q ueridos, promoviendo u na integración exitosa y sostenible en sus comunidades de origen.
                </h6>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Objetivo del Programa</h5>
                <p>
                Coadyuvar a reducir las desigualdades y mejorar las condiciones de vida de la población migrante hidalguense y sus familias, a través de acciones igualitarias y sostenibles que permitan reducir los efectos negativos propios de la migración a fin de fortalecer su desarrollo integral en aspectos económicos, laborales, familiares, sociales, culturales y les permita el goce de sus derechos en sus lugares de origen, tránsito y destino.
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Población Objetivo</h5>
                <p>
                Personas migrantes hidalguenses en el exterior, en retorno y sus familias que radiquen en el estado de Hidalgo.
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Cobertura</h5>
                <p>
                En los 84 municipios del estado de Hidalgo y los Estados Unidos.
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Vigencia</h5>
                <p>
                Anual
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Áreas de atención</h5>
                <p>
                  
                <ul>
                <li><b>Secretaría de Bienestar en Inclusión Social</b></li>
                <dd>Blvd. Felipe Angeles, Km. 93.50, Centro Minero, Edificio 1B, Col, Venta Prieta, 42080 Pachuca de Soto, Hgo.</dd>
                <li><b>Subsecretaría de Desarrollo Social y Humano</b>
                </li>
                <li><b>Dirección General de Atención al Migrante</b>
                </li>
                </ul>
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Personas Responsables del Programa</h5>
                <p>  
                <ul>
                <li>Lic. Manuel Enrique Aranda Montero: Director General de Atención al Migrante<br />                    
                </li>
                </ul></p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Teléfono de Contacto</h5>
                <p>
                771 200 4358<br />                             
                </p>
                 <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}><strong>Convocatorias</strong></h5>
                 <p>
                </p>
                 <ul>
                 <li>
                <a
                href='/assets/pdfs/CONVOCATORIA_MIGRANTES_2025.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >2025</a>
                </li>
                </ul>
                <p>
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}><strong>Reglas de Operación</strong></h5>
                <p>
                </p>
                <ul>
                <li>
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2025/ROPs_Programa_de_Atenci%C3%B3n_a_Personas_Migrantes_EF_2025.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >ROP's 2025</a>
                </li>
                <li>
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2024/ROP_Atenci%C3%B3n_al_Migrante_2024_ene_31_alc7_05.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >ROP's 2024</a>
                </li>
                </ul>
                <ul>
                <li>
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2024/Reforma_ROP_Programa_de_Atenci%C3%B3n_al_Migrante_2024.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Reforma 02 de febrero de 2024</a><br />
                </li>
                <li>
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2024/Reforma0209_ROP_Programa_de_Atencion_al_Migrante_2024..pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Reforma 02 de septiembre de 2024</a><br />
                  </li>
                  </ul>
                <p>
                </p>
              </div>
            </div>
            
          </div>
        </div>
      </div>    
    </div>
  );
};

export default Atencionmigrante;